(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-shelf-2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ugc-shelf')) {
  class UgcShelf extends HTMLElement {
    connectedCallback() {
      this.pins = Array.from(this.querySelectorAll('.ugc-pin'));
      this.highlights = Array.from(this.querySelectorAll('.ugc-highlight'));
      this.lightbox = this.querySelector('[data-ugc-lightbox]');
      this.player = this.querySelector('[data-ugc-player]');
      this.dotsWrap = this.querySelector('[data-ugc-dots]');
      this.captionEl = this.querySelector('[data-ugc-caption]');
      this.productWrap = this.querySelector('[data-ugc-product]');
      this.productImage = this.querySelector('[data-ugc-product-image]');
      this.productName = this.querySelector('[data-ugc-product-name]');
      this.productPrice = this.querySelector('[data-ugc-product-price]');
      this.addCartBtn = this.querySelector('[data-ugc-add-cart]');
      this.muteBtn = this.querySelector('[data-ugc-mute]');
      this.muteIcon = this.querySelector('[data-ugc-mute-icon]');
      this.toast = this.querySelector('[data-ugc-toast]');
      this.current = 0;
      this.isMuted = true;

      this.pins.forEach((pin, i) => {
        pin.addEventListener('click', () => this.open(i));
      });

      this.highlights.forEach((bubble) => {
        bubble.addEventListener('click', () => {
          const index = Number(bubble.dataset.ugcIndex);
          this.open(index);
        });
      });

      this.querySelector('[data-ugc-close]').addEventListener('click', () => this.close());
      this.querySelector('[data-ugc-prev]').addEventListener('click', () => this.load(this.current - 1));
      this.querySelector('[data-ugc-next]').addEventListener('click', () => this.load(this.current + 1));
      this.lightbox.addEventListener('click', (e) => { if (e.target === this.lightbox) this.close(); });
      this.muteBtn.addEventListener('click', () => this.toggleMute());
      this.addCartBtn.addEventListener('click', () => this.addToCart());
      this.player.addEventListener('ended', () => this.load(this.current + 1));

      document.addEventListener('keydown', (e) => {
        if (this.lightbox.hidden) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') this.load(this.current - 1);
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') this.load(this.current + 1);
      });

      let touchStartY = null;
      this.lightbox.addEventListener('touchstart', (e) => { touchStartY = e.touches[0].clientY; }, { passive: true });
      this.lightbox.addEventListener('touchend', (e) => {
        if (touchStartY === null) return;
        const dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dy) > 60) { dy < 0 ? this.load(this.current + 1) : this.load(this.current - 1); }
        touchStartY = null;
      }, { passive: true });
    }

    buildDots() {
      this.dotsWrap.innerHTML = this.pins.map(() => '<span><i></i></span>').join('');
    }

    updateDots() {
      Array.from(this.dotsWrap.children).forEach((el, idx) => {
        el.classList.remove('is-active', 'is-done');
        if (idx < this.current) el.classList.add('is-done');
        if (idx === this.current) el.classList.add('is-active');
      });
    }

    load(index) {
      this.current = (index + this.pins.length) % this.pins.length;
      const pin = this.pins[this.current];
      const d = pin.dataset;

      this.player.src = d.src;
      this.player.muted = this.isMuted;
      this.player.currentTime = 0;
      this.player.play().catch(() => {});
      this.captionEl.textContent = `${d.handle} \u00b7 "${d.caption}"`;

      if (d.productTitle) {
        this.productWrap.hidden = false;
        this.productImage.src = d.productImage || '';
        this.productName.textContent = d.productTitle;
        this.productPrice.textContent = d.productPrice || '';
        const available = d.available === 'true';
        this.addCartBtn.textContent = available ? `Add to cart \u2014 ${d.productPrice}` : 'View product';
        this.addCartBtn.disabled = false;
      } else {
        this.productWrap.hidden = true;
      }

      this.updateDots();

      const bubble = this.highlights[this.current];
      if (bubble) bubble.classList.add('is-seen');
    }

    open(index) {
      this.buildDots();
      this.load(index);
      this.lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      this.querySelector('[data-ugc-close]').focus();
    }

    close() {
      this.lightbox.hidden = true;
      document.body.style.overflow = '';
      this.player.pause();
    }

    toggleMute() {
      this.isMuted = !this.isMuted;
      this.player.muted = this.isMuted;
      this.muteIcon.innerHTML = this.isMuted
        ? '<path d="M11 5L6 9H3v6h3l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/>'
        : '<path d="M11 5L6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 010 7"/><path d="M18.5 5.5a9 9 0 010 13"/>';
      this.muteBtn.setAttribute('aria-label', this.isMuted ? 'Unmute' : 'Mute');
    }

    showToast(message) {
      this.toast.textContent = message;
      this.toast.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => this.toast.classList.remove('is-visible'), 2200);
    }

    addToCart() {
      const pin = this.pins[this.current];
      const d = pin.dataset;

      if (d.available !== 'true') {
        window.location.href = d.productUrl;
        return;
      }

      this.addCartBtn.disabled = true;
      this.addCartBtn.textContent = 'Adding\u2026';

      fetch(window.Shopify && Shopify.routes && Shopify.routes.root ? `${Shopify.routes.root}cart/add.js` : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(d.variantId), quantity: 1 }] }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('cart-add-failed');
          return res.json();
        })
        .then(() => {
          this.showToast(`Added "${d.productTitle}" to cart`);
          this.addCartBtn.textContent = `Add to cart \u2014 ${d.productPrice}`;
          this.addCartBtn.disabled = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(() => {
          this.showToast('Could not add to cart');
          this.addCartBtn.textContent = `Add to cart \u2014 ${d.productPrice}`;
          this.addCartBtn.disabled = false;
        });
    }
  }

  customElements.define('ugc-shelf', UgcShelf);
}

  } catch(e) { console.error(e); }
})();
})();
